import styled from 'styled-components'

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  margin: 12px 0;

  @media (min-width: 700px) and (max-width: 1023px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`

export const CardItemContainer = styled.div`
  flex-grow: 1;
  width: 100%;
`

export const Card = styled.div<{
  backgroundColor?: string
  image?: string
  iconSize?: number
}>`
  background-color: ${({ backgroundColor }) => backgroundColor || '#006BFF'};
  color: white;
  width: 100%;
  height: 128px;
  border: 1px solid #bcbcbe;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 12px;

  ${({ image, iconSize }) =>
    image &&
    `
    background-image: url(${image});
    background-size: ${iconSize || 62}px;
    background-repeat: no-repeat;
    background-position: bottom 12px left 12px;
  `}
`

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;

  button {
    width: 32px;
    height: 32px;
    background: transparent;
    border-color: white;

    figure {
      color: white !important;
    }
  }

  > div {
    width: auto;
  }
`

export const Title = styled.h3`
  position: relative;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`

export const Content = styled.section`
  width: 100%;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Count = styled.div`
  font-size: 48px;
  font-weight: 400;
  line-height: 56px;
`

export const Unit = styled.span`
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  margin-top: 4rem;
`
export const CountContainer = styled.div`
  display: flex;
  gap: 8px;
`

export const GroupedCardChartContainer = styled.div`
  nav {
    outline: 0;
    padding: 0;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const MouseOverContainerPosition = styled.div<{
  $top: string
  $left: string
}>`
  position: absolute;
  top: ${({ $top }) => $top};
  left: ${({ $left }) => $left};
  width: 264px;
  height: auto;
  pointer-events: none;
  z-index: 999;
  text-align: left;

  & > div {
    pointer-events: none;
  }
`

export const BrazilMapGrid = styled.div<{ displayNationalMinimap?: boolean }>`
  display: grid;
  ${({ displayNationalMinimap }) => `
    grid-template-rows: ${displayNationalMinimap ? '132px 1fr' : '1fr'};
  `}
`
